import React from 'react';

export interface InfoItemProps {
  icon: React.ReactNode;
  label: string;
  value: string | number | null | undefined;
}

export const InfoItem: React.FC<InfoItemProps> = ({ icon, label, value }) => {
  if (!value && value !== 0) return null;

  return (
    <div className="flex items-start gap-3 p-3 rounded-lg transition-all duration-200 hover:bg-primary/5 bg-gray-50/50">
      <div className="flex-shrink-0 w-5 h-5 text-primary/70 mt-0.5">
        {icon}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-gray-600 mb-1">{label}</p>
        <p className="text-sm break-words text-gray-900">
          {typeof value === 'number' ? value.toLocaleString('fr-FR') : value}
        </p>
      </div>
    </div>
  );
};
